module.exports = __webpack_public_path__ + "media/hyper/images/payments/cod-b4c977872823fe481c7aeb923a53374d.png";